import styled from 'styled-components';

export const StyledDel = styled.del`
  color: ${(p) => p.theme.alias.fg};
  text-decoration: line-through;
`;
